import { memo } from "react";
import type { SearchHit } from "../../../../api/src/algolia";
import { SearchResult } from "./SearchResult";

export const SearchResultList = memo(
  ({
    searchResults,
    goToSection,
    searchTerm,
    cropTo,
  }: {
    searchResults: SearchHit[];
    goToSection?: (sectionHash: string) => void;
    searchTerm?: string;
    cropTo?: number;
  }) => {
    return searchResults.map((item) => (
      <SearchResult
        key={item.objectID}
        searchResult={item}
        goToSection={goToSection}
        searchTerm={searchTerm}
        cropTo={cropTo}
      />
    ));
  },
);
